<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span
          i.fa-solid.fa-shop
      h1 El silvestre cm
   

    .bloque-texto-g.color-acento-contenido.p-3.p-sm-4.p-md-5
      .bloque-texto-g__img
        .video-wrapper
          iframe(
            width="100%",
            height="100%",
            src="https://www.youtube.com/embed/lze758fNf7U?si=2Q86dnLUJPgCdjup",
            title="YouTube video player",
            frameborder="0",
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
            allowfullscreen
          )
      .bloque-texto-g__texto.p-4
        p.mb-0 Silvestre CM es una experiencia gastronómica donde la creatividad y el sabor se fusionan. Nuestro restaurante de comida de autor ofrece platos únicos que exaltan los ingredientes locales con un toque moderno y auténtico. Ven y descubre un lugar donde cada plato cuenta una historia. 
    
    .row.justify-content-center.align-items-center
      .col-sm-auto.text-center
        a.boton.color-acento-botones(href="https://maps.app.goo.gl/jLDjY6EWYAD5Kf558" target="_blank")
          span.text-black Clic para ver ubicacion
          i.fa-solid.fa-location-dot.text-black

    separador

    .row.bg-3
      .col-12
        .p-5
          #t_1_1.titulo-segundo.color-acento-contenido
            h2 Rápidas Silvestre

          .tarjeta.bg-2.p-4
            SlyderA(tipo="b")

              .row.justify-content-center.align-items-center.my-lg-4
                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img1.png', alt='')

                .col-md-6.mb-4.mb-md-0.mt-4
                  h4 HAMBURGUESA CLÁSICA
                  p Pan artesanal, carne de res, tocineta, vegetales, cebolla crispi, queso mozzarella fundido y salsa de la casa.
                  P #[b $18.000]

              .row.justify-content-center.align-items-center.my-lg-4
                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img2.png', alt='')

                .col-md-6.mb-4.mb-md-0.mt-4
                  h4 HAMBURGUESA DEL CAMPO
                  p Pan artesanal, carne de res, toci- neta, vegetales, cebolla crispi, patacón maduro, queso mozzare- lla fundido, salsa de la casa y huevo de codorniz frito.
                  P #[b $22.000]

              .row.justify-content-center.align-items-center.my-lg-4
                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img3.png', alt='')

                .col-md-6.mb-4.mb-md-0.mt-4
                  h4 HAMBURGUESA SILVESTRE
                  p Pan artesanal, carne rellena de queso cheddar, tocineta, pepinillos, cebolla crispi, salsa de la casa, vegetal
                  P #[b $24.000]

              .row.justify-content-center.align-items-center.my-lg-4
                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img4.png', alt='')

                .col-md-6.mb-4.mb-md-0.mt-4
                  h4 HAMBURGUESA DÚO
                  p Pan artesanal, doble carne o carne y pollo apanado, doble tocineta, cebolla crispi, salsa de la casa, vegetales y para rematar un 
                  P #[b $24.000]


          separador
          #t_1_2.titulo-segundo.color-acento-contenido
            h2 CAZUELAS DE PAPAS

          .tarjeta.bg-2.p-4
            SlyderA(tipo="b")

              .row.justify-content-center.align-items-center.my-lg-4
                .col-md-6.mb-4.mb-md-0.mt-4
                  h4 CAZUELAS CHIDAS
                  p Papas a la francesa, salchicha tipo americana, pico e gallo, ropa vieja y queso cheddar.
                  P #[b $20.000]

                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img5.png', alt='')

                
              .row.justify-content-center.align-items-center.my-lg-4
                .col-md-6.mb-4.mb-md-0.mt-4
                  h4 CAZUELA CHICK
                  p Papas a la francesa, salchicha tipo americana, queso mozzarella fundido, tocineta y bastones de pollo apanados.
                  P #[b $20.000]

                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img6.png', alt='')

              .row.justify-content-center.align-items-center.my-lg-4
                .col-md-6.mb-4.mb-md-0.mt-4
                  h4 CAZUELA CREOLE
                  p Papas a la francesa, salchicha tipo americana, ropa vieja, chorizo, maicitos y maduritos, queso mozzarella fundido.
                  P #[b $24.000]

                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img7.png', alt='')

          
          separador
          #t_1_3.titulo-segundo.color-acento-contenido
            h2 PARILLA

          .tarjeta.tarjeta--gris.p-4
            PasosB.color-acento-contenido
              .row(titulo="PARILLADA X 2")
                .col-md-6.mb-4.mb-md-0
                  h3 PARILLADA X 2
                  P Lomo de cerdo, pollo, solomo de res, chorizo, costilla y panceta al horno, papas criollas, papas francesas, yuquitas, tomate, limón y chicharrón.
                  p #[b $50.000]

                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img8.png', alt='Texto que describa la imagen')

              .row(titulo="CHURRASCO")
                .col-md-6.mb-4.mb-md-0
                  h3 CHURRASCO
                  P Churrasco 270gr, ensalada de temporada y papas a la francesa.
                  p #[b $30.000]

                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img9.png', alt='Texto que describa la imagen')

              .row(titulo="COSTILLAS SILVESTRES")
                .col-md-6.mb-4.mb-md-0
                  h3 COSTILLAS SILVESTRES
                  P Costillas de cerdo horneadas y bañadas en BBQ de lulo, acompañadas de papas a la francesa.
                  p #[b $20.000]

                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img10.png', alt='Texto que describa la imagen')

              .row(titulo="CHORIZOS")
                .col-md-6.mb-4.mb-md-0
                  h3 CHORIZOS
                  P 2 chorizos de cerdo acompañados de papas criollas, limón y chimichurri.
                  p #[b $15.000]

                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img11.png', alt='Texto que describa la imagen')

                
                

          separador
          #t_1_4.titulo-segundo.color-acento-contenido
            h2 TACOS

          .tarjeta.tarjeta--gris.p-4
            LineaTiempoC.color-acento-contenido(text-small)
              .row(titulo="Tacos de Birria x3")
                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img12.png', alt='Texto que describa la imagen')

                .col-md-6.mb-4.mb-md-0
                  p.mt-4 Tortilla de maíz, guacamole, maíz tierno, carne deshebrada en su caldo de Birria y cilantro.

              .row(titulo="Tacos mi Tierra x3")
                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img13.png', alt='Texto que describa la imagen')

                .col-md-6.mb-4.mb-md-0
                  p.mt-4 Tortilla de maíz, guacamole, maduritos, chicharrón caramelizada y cilantro.

              .row(titulo="Tacos de Pollo")
                .col-md-6
                  figure
                    img(src='@/assets/curso/silvestre/img14.png', alt='Texto que describa la imagen')

                .col-md-6.mb-4.mb-md-0
                  p.mt-4 Tortilla de maíz, guacamole, maíz tierno, pollo deshebrado y cilantro.
          
          separador
          #t_1_5.titulo-segundo.color-acento-contenido
            h2 ALITAS

          TabsA.color-acento-botones.mb-5
            .tarjeta.color-acento-botones--borde.p-4(titulo="Personal")
              ul.lista-ul--color
                li.d-flex
                  i.fa-solid.fa-greater-than
                  |
                  p.mb-0 Alitas x 6 con papas
                li.d-flex
                  i.fa-solid.fa-greater-than
                  |
                  p.mb-0 1 limonada y 2 salsas.
    
              P #[b Precio: $18.000]

              figure
                img(src='@/assets/curso/silvestre/img15.png', alt='')

            .tarjeta.color-acento-botones--borde.p-4(titulo="Duo")
              ul.lista-ul--color
                li.d-flex
                  i.fa-solid.fa-greater-than
                  |
                  p.mb-0 Alitas x 12 con papas
                li.d-flex
                  i.fa-solid.fa-greater-than
                  |
                  p.mb-0 2 limonadas y 2 salsas.
    
              P #[b Precio: $35.000]

              figure
                img(src='@/assets/curso/silvestre/img16.png', alt='')


            .tarjeta.color-acento-botones--borde.p-4(titulo="Para amigos")
              ul.lista-ul--color
                li.d-flex
                  i.fa-solid.fa-greater-than
                  |
                  p.mb-0 Alitas x 18 con papas
                li.d-flex
                  i.fa-solid.fa-greater-than
                  |
                  p.mb-0 3 limonadas y 2 salsas.
    
              P #[b Precio: $50.000]

              figure
                img(src='@/assets/curso/silvestre/img17.png', alt='')

            .tarjeta.color-acento-botones--borde.p-4(titulo="Familiar")
              ul.lista-ul--color
                li.d-flex
                  i.fa-solid.fa-greater-than
                  |
                  p.mb-0 Alitas x 24 con papas
                li.d-flex
                  i.fa-solid.fa-greater-than
                  |
                  p.mb-0 4 limonadas o gaseosa 1.5lt, y 2 salsas.
    
              P #[b Precio: $68.000]

              figure
                img(src='@/assets/curso/silvestre/img18.png', alt='')
                

          separador
          #t_1_6.titulo-segundo.color-acento-contenido
            h2 Síguenos

          .row
            .col-sm-6.col-lg-3.mb-4.mb-lg-0
              a(href="https://www.instagram.com/elsilvestre.cm?igsh=b3FwZmFpczVrZjY=", target="_blank", style="text-decoration: none; color: inherit;")
                .tarjeta--boton.color-primario.p-4
                  .row.justify-content-center.mb-3
                    .col-7
                      figure
                        img(src='@/assets/curso/silvestre/ig.svg', style="width:48px").m-auto

                  h3.text-center @elsilvestre.cm


            .col-sm-6.col-lg-3.mb-4.mb-lg-0
              .tarjeta--boton.color-secundario.p-4
                .row.justify-content-center.mb-3
                  .col-7
                    figure
                      img(src='@/assets/curso/silvestre/silvestre.svg', alt='Texto que describa la imagen')

                h3.text-center Domicilios
                h3.text-center 3002262165


  




</template>

<script>
export default {
  name: 'Tema2',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
